export type CustomInfos = {
    pcUrl?: string
    mobileUrl?: string
}

export const REGISTER_TYPE = {
    DEFAULT: 'default',
    SIMPLE: 'simple',
} as const

export type RegisterType = Constant<typeof REGISTER_TYPE>

export const SUBSCRIPTION_TYPE = {
    /** 정기결제 타입 (I: 신규, U: 변경) */
    NEW: 'I',
    UPDATE: 'U',
} as const

export type SubscriptionType = Constant<typeof SUBSCRIPTION_TYPE>
